import querystring from 'querystring'

import assert from 'shared/utils/assert'
import { validate } from './helpers/pznValidator'
import BackendAPIService from './BackendAPIService'

const API_VERSION = 'v3'

class ProductService extends BackendAPIService {
  constructor(props) {
    super(props)

    this.apiVersion = API_VERSION
  }

  getBasePath() {
    return `/cacheable/${this.language}/products/${this.apiVersion}/${this.tenantPath}`
  }

  getProductPath(id) {
    const { pzn } = validate(id) // todo conditional if PZN is not valid

    return `${this.getBasePath()}/${pzn}`
  }

  getProductVariantsPath(id) {
    return `${this.getProductPath(id)}/variants`
  }

  getProductVariantsParams = () => {
    // params should not be multiline, because otherwise the whitespace is
    // preserved in the final query param.
    const variantProps = [
      'id',
      'name',
      'canonicalURL',
      'discount',
      'unit',
      'unitQuantityString',
      'unitPricing',
      'followUpProductCode',
      'brandName',
      'manufacturerCode',
      'descriptionExtra',
      'descriptionShort',
      'rating',
      'thumbnailURL',
      'numberOfRatings'
    ].join(' ')
    const pricesProps = ['amount', 'bonus', 'type'].join(' ')
    const stockStatusProps = ['status', 'statusColor', 'statusReason'].join(' ')

    return {
      fields: `variants {
          ${variantProps}
          prices { ${pricesProps} }
          stockStatus { ${stockStatusProps} }
        }`.replace(/\s+/g, ' ')
    }
  }

  getMultipleProductsPath(ids, params) {
    const pzns = ids
      .map(id => {
        const { pzn } = validate(id)
        return pzn
      })
      .filter(Boolean)
      .join(',')

    const fullRequestPath = `${this.getBasePath()}/multiple/${pzns}`
    const fullQueryString = querystring.encode(params)

    return fullQueryString
      ? `${fullRequestPath}?${fullQueryString}`
      : fullRequestPath
  }

  async fetchProduct(id, params) {
    assert(id, 'ProductService.fetchProduct: please provide an "id"')
    this.logger.debug(`Fetching product ${id}`, 'dataFetching')
    const response = await this.get(this.getProductPath(id), { params })
    this.logger.debug(`Product ${id} fetched!`, 'dataFetching')
    return response
  }

  async fetchProductVariants(id) {
    assert(id, 'ProductService.fetchProductVariants: please provide an "id"')
    this.logger.debug(`Fetching ProductVariants ${id}`, 'dataFetching')
    const path = this.getProductVariantsPath(id)
    const response = await this.get(path, {
      params: this.getProductVariantsParams()
    })
    this.logger.debug(`ProductVariants ${id} fetched!`, 'dataFetching')
    return response
  }

  async fetchMultipleProducts(ids, params = null) {
    assert(
      ids,
      'ProductService.fetchMultipleProducts: please provide the "ids"'
    )

    this.logger.debug(`Fetching fetchMultipleProducts`, 'dataFetching')
    const response = await this.get(this.getMultipleProductsPath(ids, params))
    this.logger.debug(`fetchMultipleProducts fetched!`, 'dataFetching')
    return response
  }
}

export default ProductService
